
import { Skills } from "../Skills";
import "./Timeline.scss";    
  
type TimelineProps = {
  goToProject: (name: string) => void;
};

export default function Timeline({ goToProject }: TimelineProps) {
  let goToProjectFunc = (name : string) => {return () => goToProject(name)} 

  return (<ul className="timeline">
    <li>  
      <div className="bottom-text"><span className="text-gradient">2025</span></div>
      <h4 id="2025-2026" className="title">IRIT</h4>
      <div className="description">Ingénieur de recherche - Informatique graphique</div>
      <a href="#sec-projects" onClick={goToProjectFunc("ponca")}>Dévelopement librairie d'analyse de nuage de Point</a>  
      <Skills names={["C++", "CUDA", "Eigen", "LibIGL"].reverse()}/>
    </li>
    <li>
      <div className="bottom-text"><span className="text-gradient">2024</span></div>
      <h4 id="2024-2025" className="title">Alten</h4>
      <div className="description">Ingénieur - Informatique graphique</div>  
      <a href="#sec-projects" onClick={goToProjectFunc("alten")}>Developement logiciel de rendu de pièce défectueuse</a> 
      <Skills names={["Python", "OpenGL", "ImGui"].reverse()}/>
    </li>
    <li>
      <div className="bottom-text"><span className="text-gradient">2022</span></div> 
      <h4 id="2022-2024" className="title">Master d'informatique graphique (ISICG)</h4>
      <div className="description">Université de Limoges</div> 
      <a href="#sec-projects" onClick={goToProjectFunc("cea")}>Stage de fin d'Etude au CEA</a> 
      <details>
        <summary>Spécialisation IA</summary> 
        <Skills names={["TensorFlow", "Keras"]}/>
      </details>
      <Skills names={["C++", "OpenGL", "CUDA"]}/>
    </li>
    <li> 
      <div className="bottom-text"><span className="text-gradient">2019</span></div> 
      <h4 id="2019-2022" className="title">Licence informatique</h4>
      <div className="description">INU Champollion d'Albi</div>
      
      <details>
        <summary>Specialisation WEB</summary> 
        <Skills names={["JavaScript", "NodeJS", "React"].reverse()}/>
      </details>
      <Skills names={["Python", "Java"]}/>
    </li>  
  </ul>);
}
  